import { render, staticRenderFns } from "./MarksListSecondVariant.vue?vue&type=template&id=23e6efdf"
import script from "./MarksListSecondVariant.vue?vue&type=script&lang=js"
export * from "./MarksListSecondVariant.vue?vue&type=script&lang=js"
import style0 from "./MarksListSecondVariant.vue?vue&type=style&index=0&id=23e6efdf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports